"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.seoUpsertSchema = exports.seoMetaSchema = void 0;
const zod_1 = require("zod");
// Full DB row schema — mirrors Prisma SeoMeta model exactly.
// DateTime fields are serialized to ISO strings by JSON.
// jsonLd is a Json column (arbitrary structure).
exports.seoMetaSchema = zod_1.z.object({
    id: zod_1.z.string(),
    path: zod_1.z.string(),
    locale: zod_1.z.string(),
    metaTitle: zod_1.z.string().nullable().optional(),
    metaDescription: zod_1.z.string().nullable().optional(),
    keywords: zod_1.z.string().nullable().optional(),
    ogImage: zod_1.z.string().nullable().optional(),
    canonical: zod_1.z.string().nullable().optional(),
    noindex: zod_1.z.boolean(),
    jsonLd: zod_1.z.unknown().nullable().optional(),
    createdAt: zod_1.z.string(),
    updatedAt: zod_1.z.string(),
});
// API verbatim schema (source of truth: apps/api/src/common/schemas.ts)
exports.seoUpsertSchema = zod_1.z.object({
    path: zod_1.z.string().min(1).max(255),
    locale: zod_1.z.enum(["tr", "en"]),
    metaTitle: zod_1.z.string().max(255).nullable().optional(),
    metaDescription: zod_1.z.string().nullable().optional(),
    keywords: zod_1.z.string().max(500).nullable().optional(),
    ogImage: zod_1.z.string().max(1000).nullable().optional(),
    canonical: zod_1.z.string().max(500).nullable().optional(),
    noindex: zod_1.z.boolean().default(false),
    jsonLd: zod_1.z.any().nullable().optional(),
});
//# sourceMappingURL=seo.js.map